"use client";

import React from "react";
import Link from "next/link";

export default function Footer() {
  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-screen-xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Sekce 1: O webu */}
        <div>
          <h2 className="font-bold text-lg mb-4">Profesionální ruční broušení</h2>
          <p className="text-sm text-gray-100">
            Přesvědčte se o mé kvalitě a preciznosti. Specializuji se na nože a
            další nástroje, kterým vrátím perfektní ostří.
          </p>
        </div>

        {/* Sekce 2: Rychlé odkazy */}
        <div>
          <h3 className="font-bold text-lg mb-4">Rychlé odkazy</h3>
          <ul className="space-y-2 text-sm text-gray-100">
            <li>
              <Link
                href="#blog"
                className="hover:text-secondary hover:underline"
                aria-label="Přejít na sekci Blog"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                href="#moje-prace"
                className="hover:text-secondary hover:underline"
                aria-label="Přejít na sekci Moje práce"
              >
                Moje práce
              </Link>
            </li>
            <li>
              <Link
                href="#cenik"
                className="hover:text-secondary hover:underline"
                aria-label="Přejít na sekci Ceník"
              >
                Ceník
              </Link>
            </li>
            <li>
              <Link
                href="/brouseni-nozu-postou"
                className="hover:text-secondary hover:underline"
                aria-label="Broušení nožů poštou"
              >
                Broušení poštou
              </Link>
            </li>
          </ul>
        </div>

        {/* Sekce 3: Kontakt a sociální sítě */}
        <div>
          <h3 className="font-bold text-lg mb-4">Kontaktujte mě</h3>
          <p className="text-sm text-gray-100 mb-2">
            E-mail:
            <a
              href="mailto:lesek.brouseni@gmail.com"
              className="ml-1 hover:text-secondary hover:underline"
              aria-label="Poslat e-mail na lesek.brouseni@gmail.com"
            >
              lesek.brouseni@gmail.com
            </a>
          </p>
          <p className="text-sm text-gray-100 mb-4">
            Telefon:
            <a
              href="tel:+420720126985"
              className="ml-1 hover:text-secondary hover:underline"
              aria-label="Zavolat na číslo +420 720 126 985"
            >
              +420 720 126 985
            </a>
          </p>
          {/* <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/jiri.lesek"
              className="text-white hover:text-gray-300 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook profil Jiřího Lések"
            >
              <Facebook />
            </a>
            <a
              href="https://www.instagram.com/nikshe.cz/"
              className="text-white hover:text-gray-300 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram profil NikShe.cz"
            >
              <Instagram />
            </a>
          </div> */}
        </div>

        {/* Sekce 4: Firemní údaje */}
        <div>
          <h3 className="font-bold text-lg mb-4">Firemní údaje</h3>
          <p className="text-sm text-gray-100">
            Jiří Lések
            <br />
            IČO: 17123071
            <br />
            Adresa: Tršice 271, 783 57 Tršice
          </p>
        </div>
      </div>

      {/* Spodní část */}
      <div className="text-center text-sm text-gray-200 mt-8 px-4">
        <p>
          © {new Date().getFullYear()} www.ostryto.cz Všechna práva vyhrazena.
        </p>
        <p>
          Created by:
          <a
            href="https://novakp.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-1  hover:text-secondary hover:underline"
            aria-label="Pavel Novák web developer"
          >
            Pavel Novák
          </a>
        </p>
      </div>
    </footer>
  );
}
